import useEntity from 'recoil/useEntity/useEntity'
import { IProjectCheckpoint } from '../projectCheckpoints.types'
import checkpointsTableAtom from '../components/CheckpointsTable/checkpointsTable.atom'
import projectCheckpointsApi from '../projectCheckpoints.api'
import { useMemo } from 'react'

/**
 * Получение контрольной точки. Использует атом админской таблицы контрольных точек
 * Используется в зоне админа
 * @param id id контрольной точки
 * @returns
 */
const useAdminTableProjectCheckpoint = (id: IProjectCheckpoint['id']) => {
  const { entity, loading } = useEntity({
    atom: checkpointsTableAtom,
    entityId: id,
    itemFetcher: projectCheckpointsApi.getOne,
    resource: 'project-checkpoints',
  })

  const checkpoint = useMemo(() => ({ ...entity, duration: (entity?.duration ?? 0) / 86400 }), [entity])

  return { checkpoint, loading }
}

export default useAdminTableProjectCheckpoint
